// extracted by mini-css-extract-plugin
export default {"container":"CustomModalFooter_container__Ghlvc"};